/* Werkbank – Schnellbestellung  <pp-quick-order>
   Artikelnummer → Variante (Produkt-Handle = Teil vor dem ersten „-“, sonst Suche),
   Kundenname als Warenkorb-Eigenschaft „message“ (wie die Variantentabelle der Produktseite),
   alle Zeilen in EINEM /cart/add.js-Aufruf. Gäste: Liste wird gespeichert, Login, danach wieder da. */
(function () {
  if (customElements.get('pp-quick-order')) return;

  var STORE_KEY = 'pp-sb-list-v1';
  var productCache = {};   // handle -> Promise<product|null>
  var suggestCache = {};   // query  -> Promise<{handle, variantId}|null>

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (val === null) localStorage.removeItem(STORE_KEY);
      else localStorage.setItem(STORE_KEY, JSON.stringify(val));
    } catch (e) { return null; }
  }

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* fetch mit Wiederholung bei 429 (Shopify drosselt viele schnelle Abrufe) */
  function fetchRetry(url, opts, tries) {
    tries = tries == null ? 3 : tries;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && tries > 0) return sleep(1500).then(function () { return fetchRetry(url, opts, tries - 1); });
      return r;
    });
  }

  /* kleine Warteschlange: höchstens 3 Abrufe gleichzeitig */
  var running = 0, queue = [];
  function limited(fn) {
    return new Promise(function (resolve, reject) {
      queue.push(function () {
        running++;
        fn().then(resolve, reject).then(function () { running--; next(); });
      });
      next();
    });
  }
  function next() { while (running < 3 && queue.length) queue.shift()(); }

  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) {
      if (k === 'text') e.textContent = attrs[k];
      else e.setAttribute(k, attrs[k]);
    }
    return e;
  }

  var TAG_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg>';
  var X_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"></path></svg>';

  var uid = 0;

  class PpQuickOrder extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var d = this.dataset;
      this.dealer = d.dealer === 'true';
      this.isCustomer = d.customer === 'true';
      // Preis-Freigabe wie Produktseite (pp-variantentabelle: preise_frei = quantity_price_breaks am Produkt)
      // gilt JE PRODUKT – siehe pricesFor(row); hier gibt es keinen seitenweiten Schalter.
      this.root = d.root || '/';
      this.sectionId = d.section || 'pp-schnellbestellung';
      this.cartUrl = d.cartUrl || '/cart';
      this.afterAdd = d.afterAdd || 'notice';
      // Dezimalkomma in Optionswerten wie Variantentabelle (komma außer bei Sprache en)
      this.komma = d.komma !== 'false';
      try { this.t = JSON.parse(this.querySelector('[data-pp-sb-i18n]').textContent); } catch (e) { this.t = {}; }
      try {
        this.money = new Intl.NumberFormat(d.locale || 'de', { style: 'currency', currency: d.currency || 'EUR' });
      } catch (e) { this.money = { format: function (n) { return n.toFixed(2) + ' €'; } }; }

      this.body = this.querySelector('[data-pp-sb-body]');
      this.msg = this.querySelector('[data-pp-sb-msg]');
      this.rows = [];

      var saved = store(true);
      if (saved && saved.length) {
        var self = this;
        saved.forEach(function (s) { self.addRow(s); });
        this.ensureEmptyRow();
      } else {
        var n = parseInt(d.rows, 10) || 3;
        for (var i = 0; i < n; i++) this.addRow();
      }

      var self = this;
      var csvBtn = this.querySelector('[data-pp-sb-csv]');
      if (csvBtn) csvBtn.addEventListener('click', function () { self.applyCsv(); });
      var addBtn = this.querySelector('[data-pp-sb-add]');
      if (addBtn) addBtn.addEventListener('click', function () { self.addToCart(addBtn); });
      var loginBtn = this.querySelector('[data-pp-sb-login]');
      if (loginBtn) loginBtn.addEventListener('click', function () { self.save(true); });
      var clearBtn = this.querySelector('[data-pp-sb-clear]');
      if (clearBtn) clearBtn.addEventListener('click', function () { self.clear(); });

      /* schmale Breite → gestapelte Karten (ohne Container Queries, Chrome 112) */
      var apply = function () {
        var w = self.clientWidth;
        if (!w) return;
        self.classList.toggle('is-narrow', w < 640);
        self.classList.toggle('is-compact', w >= 640 && w < 920);
        self.rows.forEach(function (r) { self.placeOpts(r); });
      };
      apply();
      if (window.ResizeObserver) new ResizeObserver(apply).observe(this);
      else window.addEventListener('resize', apply);
    }

    /* ---------- Zeilen ---------- */
    addRow(init) {
      init = init || {};
      var t = this.t, self = this, n = ++uid;
      var row = { sku: init.sku || '', qty: Math.max(1, parseInt(init.qty, 10) || 1), name: init.name || '', vid: init.vid || null, product: null, variant: null, state: 'empty' };
      var tr = el('tr', 'pp-sb__row');
      row.tr = tr;

      // Artikelnr.
      var tdSku = el('td', 'pp-sb__c-sku');
      var skuId = 'pp-sb-sku-' + n;
      tdSku.appendChild(el('label', 'pp-sb__mlabel', { for: skuId, text: t.colSku || 'Item no.' }));
      var inp = el('input', 'pp-sb__sku pp-mono', { id: skuId, type: 'text', autocomplete: 'off', autocapitalize: 'characters', spellcheck: 'false', placeholder: t.placeholder || '', 'aria-describedby': 'pp-sb-err-' + n });
      inp.value = row.sku;
      var skuWrap = el('div', 'pp-sb__skuwrap');
      skuWrap.appendChild(inp);
      // Handy: Knopf „Hinzufügen“ neben dem Eingabefeld (nur in der Eingabezeile sichtbar, siehe CSS .is-narrow)
      var go = el('button', 'pp-sb__go', { type: 'button', text: t.addRow || 'Add' });
      skuWrap.appendChild(go);
      tdSku.appendChild(skuWrap);
      row.inp = inp;

      // Artikel: Bild, Titel, Variante, Fehler
      var tdItem = el('td', 'pp-sb__c-item');
      var item = el('div', 'pp-sb__item');
      row.img = el('img', 'pp-sb__img', { alt: '', width: '52', height: '52', loading: 'lazy', hidden: '' });
      var info = el('div', 'pp-sb__info');
      row.title = el('a', 'pp-sb__ptitle', { hidden: '' });
      row.vtext = el('p', 'pp-sb__vtext');
      // Variantenauswahl: je Produktoption ein Auswahlfeld (wird in buildOpts() je Produkt aufgebaut)
      row.n = n;
      row.opts = el('div', 'pp-sb__opts', { hidden: '', role: 'group', 'aria-label': t.variant || 'Variant' });
      row.err = el('p', 'pp-sb__err', { id: 'pp-sb-err-' + n, role: 'alert', 'aria-live': 'assertive', 'aria-atomic': 'true' });
      info.appendChild(row.title); info.appendChild(row.vtext); info.appendChild(row.err);
      item.appendChild(row.img); item.appendChild(info);
      tdItem.appendChild(item);
      tdItem.appendChild(row.opts); // unter Bild + Titel, volle Spaltenbreite
      row.tdItem = tdItem;
      // mittlere Breite (Hero): Auswahlfelder in eigener Rasterzeile über die ganze Breite (siehe placeOpts)
      row.tdOpts = el('td', 'pp-sb__c-opts');

      // Lieferzeit
      var tdLz = el('td', 'pp-sb__c-lz');
      tdLz.appendChild(el('span', 'pp-sb__mlabel', { 'aria-hidden': 'true', text: t.colLz || 'Delivery time' }));
      row.lz = el('span', 'pp-sb__lz');
      tdLz.appendChild(row.lz);

      // Preis
      var tdPrice = el('td', 'pp-sb__c-price');
      tdPrice.appendChild(el('span', 'pp-sb__mlabel', { 'aria-hidden': 'true', text: t.colPrice || 'Price' }));
      row.price = el('span', 'pp-sb__price');
      tdPrice.appendChild(row.price);

      // Kundenname (Etikett)
      var tdName = el('td', 'pp-sb__c-name');
      var nameId = 'pp-sb-name-' + n;
      var lab = el('label', 'pp-sb__name', { for: nameId, title: t.nameHint || '' });
      lab.innerHTML = TAG_SVG;
      lab.appendChild(el('span', 'pp-visually-hidden', { text: (t.colName || 'Customer name') + ' – ' + (t.nameHint || '') }));
      row.nameInp = el('input', '', { id: nameId, type: 'text', autocomplete: 'off', maxlength: '60', placeholder: t.namePlaceholder || '' });
      row.nameInp.value = row.name;
      lab.appendChild(row.nameInp);
      tdName.appendChild(lab);

      // Menge
      var tdQty = el('td', 'pp-sb__c-qty');
      var qtyId = 'pp-sb-qty-' + n;
      tdQty.appendChild(el('label', 'pp-sb__mlabel', { for: qtyId, text: t.colQty || 'Quantity' }));
      var q = el('div', 'pp-sb__qty');
      var minus = el('button', 'pp-sb__qbtn', { type: 'button', 'aria-label': t.minus || '−' }); minus.textContent = '−';
      row.qtyInp = el('input', 'pp-sb__qinp pp-mono', { id: qtyId, type: 'number', inputmode: 'numeric', min: '1', step: '1' });
      row.qtyInp.value = row.qty;
      var plus = el('button', 'pp-sb__qbtn', { type: 'button', 'aria-label': t.plus || '+' }); plus.textContent = '+';
      q.appendChild(minus); q.appendChild(row.qtyInp); q.appendChild(plus);
      tdQty.appendChild(q);

      // entfernen
      var tdX = el('td', 'pp-sb__c-x');
      row.rm = el('button', 'pp-sb__rm', { type: 'button', 'aria-label': t.remove || 'Remove row', title: t.remove || '' });
      row.rm.innerHTML = X_SVG;
      tdX.appendChild(row.rm);

      [tdSku, tdItem, tdLz, tdPrice, tdName, tdQty, tdX, row.tdOpts].forEach(function (c) { tr.appendChild(c); });
      this.body.appendChild(tr);
      this.rows.push(row);

      // Ereignisse
      var timer = null;
      inp.addEventListener('input', function () {
        row.sku = inp.value.trim();
        clearTimeout(timer);
        self.ensureEmptyRow();
        timer = setTimeout(function () { self.resolve(row); }, 600);
      });
      inp.addEventListener('change', function () { clearTimeout(timer); row.sku = inp.value.trim(); self.resolve(row); });
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault(); clearTimeout(timer); row.sku = inp.value.trim(); self.resolve(row);
          row.qtyInp.focus();
        }
      });
      row.nameInp.addEventListener('input', function () { row.name = row.nameInp.value; self.save(); });
      function setQty(v) {
        v = Math.max(1, Math.min(9999, parseInt(v, 10) || 1));
        row.qty = v; row.qtyInp.value = v; self.renderPrice(row); self.save();
      }
      minus.addEventListener('click', function () { setQty(row.qty - 1); });
      plus.addEventListener('click', function () { setQty(row.qty + 1); });
      row.qtyInp.addEventListener('change', function () { setQty(row.qtyInp.value); });
      row.rm.addEventListener('click', function () { self.removeRow(row); });
      go.addEventListener('click', function () {
        clearTimeout(timer); row.sku = inp.value.trim();
        if (!row.sku) { inp.focus(); return; }
        self.resolve(row);
        self.ensureEmptyRow();
        var nx = self.firstEmpty();
        if (nx && nx !== row) nx.inp.focus();
      });

      this.renderRow(row);
      if (row.sku) this.resolve(row);
      this.updateRemoveButtons();
      return row;
    }

    ensureEmptyRow() {
      var last = this.rows[this.rows.length - 1];
      if (!last || last.inp.value.trim() !== '') this.addRow();
      this.updateRemoveButtons();
    }

    firstEmpty() {
      return this.rows.filter(function (r) { return r.inp.value.trim() === ''; })[0] || null;
    }

    updateRemoveButtons() {
      var n = this.rows.length;
      var first = this.firstEmpty();
      this.rows.forEach(function (r, i) {
        var empty = r.inp.value.trim() === '';
        var lonelyEmpty = n === 1 || (i === n - 1 && empty);
        r.rm.disabled = lonelyEmpty;
        // Handy: nur EINE leere Eingabezeile zeigen (weitere leere Startzeilen ausblenden)
        r.tr.classList.toggle('is-spare', empty && r !== first);
        r.tr.classList.toggle('is-entry', empty && r === first);
      });
    }

    removeRow(row) {
      var i = this.rows.indexOf(row);
      if (i < 0) return;
      var focusTo = this.rows[i + 1] || this.rows[i - 1];
      row.tr.remove();
      this.rows.splice(i, 1);
      this.ensureEmptyRow();
      if (focusTo) focusTo.inp.focus();
      this.save();
    }

    clear() {
      this.rows.slice().forEach(function (r) { r.tr.remove(); });
      this.rows = [];
      var n = parseInt(this.dataset.rows, 10) || 3;
      for (var i = 0; i < n; i++) this.addRow();
      this.setMsg('');
      store(false, null);
    }

    save(force) {
      var list = this.rows.filter(function (r) { return r.sku; }).map(function (r) {
        return { sku: r.sku, qty: r.qty, name: r.name, vid: r.variant ? r.variant.id : r.vid };
      });
      if (!list.length && !force) { store(false, null); return; }
      store(false, list);
    }

    /* ---------- Auflösung Artikelnummer → Variante ---------- */
    resolve(row) {
      var raw = row.sku;
      if (row.resolved === raw) return;
      row.resolved = raw;
      row.product = null; row.variant = null;
      if (!raw) { row.state = 'empty'; this.renderRow(row); this.save(); return; }
      row.state = 'loading'; this.renderRow(row);
      var self = this, token = {};
      row.token = token;
      this.lookup(raw, row.vid).then(function (res) {
        if (row.token !== token) return;
        row.vid = null; row.sel = null; row.optFor = null;
        if (!res) { row.state = 'notfound'; }
        else {
          row.product = res.product;
          if (res.variant) { row.variant = res.variant; row.state = res.variant.ok ? 'ok' : 'soldout'; }
          else { row.state = 'choose'; }
        }
        self.renderRow(row);
        self.save();
      }).catch(function () {
        if (row.token !== token) return;
        row.state = 'notfound'; self.renderRow(row);
      });
    }

    lookup(raw, preferVid) {
      var self = this;
      var q = raw.trim();
      var upper = q.toUpperCase();
      var dash = q.indexOf('-');
      var handle = (dash > 0 ? q.slice(0, dash) : q).toLowerCase().replace(/[^a-z0-9_-]/g, '');

      function pick(product, vidHint) {
        if (!product) return null;
        var vs = product.variants;
        var v = null;
        if (preferVid) v = vs.filter(function (x) { return x.id == preferVid; })[0];
        if (!v) v = vs.filter(function (x) { return (x.sku || '').toUpperCase() === upper; })[0];
        if (!v && vidHint) v = vs.filter(function (x) { return x.id == vidHint; })[0];
        if (!v && vs.length === 1) v = vs[0];
        return { product: product, variant: v || null };
      }

      var first = handle ? this.loadProduct(handle) : Promise.resolve(null);
      return first.then(function (p) {
        var r = pick(p);
        if (r && r.variant) return r;
        // Fallback: Shopify-Suche (findet auch pxxl-Nummern wie RHT16 als Tag)
        return self.suggest(q).then(function (hit) {
          if (!hit) return r; // Produkt per Handle gefunden, aber keine exakte Variante → Auswahl
          if (r && hit.handle === r.product.handle) {
            // nur die Hauptnummer (= Handle) eingegeben: keine Variante vorwählen, sondern auswählen lassen
            if (upper === String(r.product.handle).toUpperCase()) return r;
            return pick(r.product, hit.variantId);
          }
          return self.loadProduct(hit.handle).then(function (p2) { return pick(p2, hit.variantId) || r; });
        });
      });
    }

    suggest(q) {
      var key = q.toUpperCase();
      if (suggestCache[key]) return suggestCache[key];
      var url = this.root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
      var p = limited(function () { return fetchRetry(url, { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var list = j && j.resources && j.resources.results && j.resources.results.products || [];
          if (!list.length) return null;
          // exakter Treffer per Tag oder Handle bevorzugen, sonst nur bei einem einzigen Ergebnis
          var exact = list.filter(function (x) {
            return (x.handle || '').toUpperCase() === key || (x.tags || []).some(function (tg) { return String(tg).toUpperCase() === key; });
          })[0];
          var withVariant = list.filter(function (x) { return /[?&]variant=\d+/.test(x.url || ''); })[0];
          var hit = exact || withVariant || (list.length === 1 ? list[0] : null);
          if (!hit) return null;
          var m = /[?&]variant=(\d+)/.exec(hit.url || '');
          return { handle: hit.handle, variantId: m ? m[1] : null };
        })
        .catch(function () { return null; });
      suggestCache[key] = p;
      return p;
    }

    loadProduct(handle) {
      if (productCache[handle]) return productCache[handle];
      var self = this;
      var base = this.root + 'products/' + encodeURIComponent(handle);
      var p = limited(function () { return fetchRetry(base + '?section_id=' + encodeURIComponent(self.sectionId)); })
        .then(function (r) {
          if (r.status === 404) return 'missing';
          if (!r.ok) return null;
          return r.text().then(function (html) {
            var m = /<script type="application\/json" data-pp-sb-product>([\s\S]*?)<\/script>/.exec(html);
            if (!m) return null;
            try { var j = JSON.parse(m[1]); j.source = 'section'; return j; } catch (e) { return null; }
          });
        })
        .then(function (j) {
          if (j === 'missing') return null;
          if (j) return j;
          // Rückfall: /products/<handle>.js (ohne Lieferzeit-Regel und ohne Händlerpreis)
          return limited(function () { return fetchRetry(base + '.js'); })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (pj) {
              if (!pj) return null;
              return {
                handle: pj.handle, title: pj.title, url: pj.url || ('/products/' + pj.handle), img: pj.featured_image || null,
                dealer: false, source: 'js', tags: pj.tags || [],
                opts: (pj.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }),
                variants: (pj.variants || []).map(function (v) {
                  return { id: v.id, sku: v.sku, t: v.public_title || v.title, o: v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }), ok: !!v.available, lz: self.t.lzDefault || '', lzc: 'fast',
                    img: v.featured_image ? v.featured_image.src : null, p: null, pb: [] };
                })
              };
            });
        })
        .catch(function () { return null; });
      productCache[handle] = p;
      return p;
    }

    setVariant(row, v) {
      row.variant = v;
      row.state = v.ok ? 'ok' : 'soldout';
      this.renderRow(row);
    }

    /* ---------- Darstellung ---------- */
    renderRow(row) {
      var t = this.t, p = row.product, v = row.variant;
      row.tr.dataset.state = row.state;
      row.err.textContent = '';
      row.inp.removeAttribute('aria-invalid');

      if (p) {
        var img = (v && v.img) || p.img;
        if (img) { row.img.src = img; row.img.alt = p.title; row.img.hidden = false; } else row.img.hidden = true;
        row.title.textContent = p.title;
        row.title.href = p.url + (v ? (p.url.indexOf('?') < 0 ? '?' : '&') + 'variant=' + v.id : '');
        row.title.hidden = false;
      } else {
        row.img.hidden = true; row.title.hidden = true; row.img.removeAttribute('src');
      }

      var multi = !!(p && p.variants && p.variants.length > 1);
      row.vtext.textContent = '';
      if (row.state === 'loading') row.vtext.textContent = t.loading || '…';
      // mit Auswahlfeldern steht die Variante schon in den Feldern → nur die Artikelnummer zeigen
      if (v) row.vtext.textContent = multi ? (v.sku || '') : (v.sku ? v.sku + ' · ' : '') + (v.t && v.t !== 'Default Title' ? this.fmt(v.t) : '');

      if (row.state === 'notfound') {
        row.err.textContent = t.notFound || 'Item number not found';
        row.inp.setAttribute('aria-invalid', 'true');
      }
      if (row.state === 'soldout') row.err.textContent = t.soldOut || '';
      if (row.state === 'choose' && p) row.err.textContent = t.choose || '';

      if (multi && row.state !== 'loading' && row.state !== 'notfound') {
        this.buildOpts(row);
        this.updateOpts(row);
        row.opts.hidden = false;
      } else {
        row.opts.hidden = true;
      }
      row.tr.classList.toggle('has-opts', !row.opts.hidden);
      this.placeOpts(row);

      // Lieferzeit
      row.lz.textContent = '';
      row.lz.className = 'pp-sb__lz';
      if (v) {
        row.lz.textContent = this.dash(v.lz || '');
        row.lz.className = 'pp-sb__lz pp-badge ' + (v.lzc === 'fast' ? 'pp-badge--ok' : v.lzc === 'out' ? 'pp-badge--line' : 'pp-badge--line pp-sb__lz--slow');
      } else if (row.state !== 'empty' && row.state !== 'loading') {
        row.lz.textContent = '–';
      }
      this.renderPrice(row);
    }

    /* ---------- Variantenauswahl: je Option ein Feld, abhängig voneinander (Kaskade) ----------
       Feld i zeigt nur Werte, die mit den Feldern 0..i-1 eine echte Variante ergeben.
       Werte, deren Varianten alle nicht bestellbar sind, sind deaktiviert und als „nicht lieferbar“ markiert. */
    optNames(p) {
      return p.opts && p.opts.length ? p.opts : [this.t.variant || 'Variant'];
    }
    vopts(p, v) {
      var n = this.optNames(p).length;
      var o = v.o && v.o.length === n ? v.o : (n === 1 ? [v.t] : (v.o || []));
      return o;
    }
    matching(row, upto) {
      var p = row.product, self = this, sel = row.sel;
      return p.variants.filter(function (v) {
        var o = self.vopts(p, v);
        for (var j = 0; j < upto; j++) if (o[j] !== sel[j]) return false;
        return true;
      });
    }
    validValues(row, i) {
      var p = row.product, self = this, seen = {}, out = [];
      this.matching(row, i).forEach(function (v) {
        var val = self.vopts(p, v)[i];
        if (val == null) return;
        if (!seen.hasOwnProperty(val)) { seen[val] = { val: val, ok: false }; out.push(seen[val]); }
        if (v.ok) seen[val].ok = true;
      });
      return out;
    }

    placeOpts(row) {
      var host = this.classList.contains('is-compact') ? row.tdOpts : row.tdItem;
      if (host && row.opts.parentNode !== host) host.appendChild(row.opts);
    }

    buildOpts(row) {
      var p = row.product;
      if (row.optFor === p.handle && row.sel) return;
      var self = this, t = this.t, names = this.optNames(p);
      row.optFor = p.handle;
      row.sel = names.map(function (_, i) { return row.variant ? self.vopts(p, row.variant)[i] : ''; });
      row.opts.innerHTML = '';
      row.optEls = [];
      row.opts.classList.toggle('pp-sb__opts--1', names.length === 1);
      row.opts.classList.toggle('pp-sb__opts--many', names.length > 3);
      names.forEach(function (name, i) {
        var id = 'pp-sb-o' + row.n + '-' + i;
        var isColor = /farb|colou?r|kolor|couleur|colore/i.test(name);
        var box = el('div', 'pp-sb__opt' + (isColor ? ' pp-sb__opt--farbe' : ''));
        box.appendChild(el('label', 'pp-sb__olabel', { for: id, text: name, title: name }));
        var wrap = el('div', 'pp-sb__owrap');
        var sw = null;
        if (isColor) {
          sw = el('span', 'pp-sb__sw', { 'aria-hidden': 'true', hidden: '' });
          wrap.appendChild(sw);
          wrap.classList.add('pp-sb__owrap--sw');
        }
        var s = el('select', 'pp-sb__select', { id: id });
        wrap.appendChild(s);
        box.appendChild(wrap);
        // Breite nach dem längsten Wert, damit z. B. „1,2 mm“ schmal und „Rosé Gold/Kristall“ breit wird
        var longest = 0;
        p.variants.forEach(function (v) { var x = self.vopts(p, v)[i]; if (x != null) longest = Math.max(longest, self.fmt(String(x).trim()).length); });
        var basis = Math.max(88, Math.min(230, Math.round(longest * 7.6) + 46 + (isColor ? 26 : 0)));
        box.style.flexBasis = basis + 'px';
        box.style.minWidth = Math.min(basis, 104) + 'px'; // kurze Werte nie abschneiden
        row.opts.appendChild(box);
        row.optEls.push({ sel: s, sw: sw, name: name });
        s.addEventListener('change', function () { self.onOpt(row, i, s.value); });
      });
    }

    updateOpts(row) {
      var self = this, t = this.t;
      row.optEls.forEach(function (o, i) {
        var s = o.sel, cur = row.sel[i];
        var prevDone = row.sel.slice(0, i).every(function (x) { return x !== ''; });
        var vals = prevDone ? self.validValues(row, i) : [];
        s.innerHTML = '';
        if (!cur) s.appendChild(el('option', '', { value: '', text: (t.optionPick || 'Choose [option]').replace('[option]', o.name) }));
        vals.forEach(function (x) {
          var op = el('option', '', { value: x.val, text: self.fmt(String(x.val).trim()) + (x.ok ? '' : ' – ' + (t.unavailable || 'unavailable')) });
          if (!x.ok) op.disabled = true;
          s.appendChild(op);
        });
        s.value = cur || '';
        s.disabled = !prevDone;
        var cls = 'pp-sb__select';
        if (cur && vals.some(function (x) { return x.val === cur && !x.ok; })) cls += ' pp-sb__select--out';
        s.className = cls;
        if (o.sw) {
          var c = cur ? self.swatch(cur) : null;
          if (c) {
            o.sw.hidden = false;
            o.sw.style.setProperty('--m', c.m);
            if (c.s) o.sw.style.setProperty('--s', c.s); else o.sw.style.removeProperty('--s');
            o.sw.innerHTML = c.s ? '<i></i>' : '';
          } else o.sw.hidden = true;
          o.sw.parentNode.classList.toggle('pp-sb__owrap--sw', !!c);
        }
      });
    }

    onOpt(row, i, val) {
      var p = row.product;
      if (!p) return;
      var wasComplete = !!row.variant;
      row.sel[i] = val;
      for (var j = i + 1; j < row.sel.length; j++) {
        var vals = row.sel[j - 1] ? this.validValues(row, j) : [];
        var keep = vals.filter(function (x) { return x.val === row.sel[j]; })[0];
        if (keep) continue;
        if (vals.length === 1) row.sel[j] = vals[0].val;
        else if (wasComplete && vals.length) row.sel[j] = (vals.filter(function (x) { return x.ok; })[0] || vals[0]).val;
        else row.sel[j] = '';
      }
      var v = null;
      if (row.sel.every(function (x) { return x !== ''; })) v = this.matching(row, row.sel.length)[0] || null;
      if (v) {
        row.variant = v; row.vid = v.id;
        row.state = v.ok ? 'ok' : 'soldout';
        if (v.sku) { row.inp.value = v.sku; row.sku = v.sku; row.resolved = v.sku; }
      } else {
        row.variant = null; row.state = 'choose';
      }
      this.renderRow(row);
      this.save();
    }

    /* Farbmuster wie snippets/pp-farbe.liquid: Teil vor „/“ = Metall (Fläche), danach = Stein (Punkt) */
    swatch(name) {
      var parts = String(name).split('/').slice(0, 2).map(function (s) { return s.trim().toLowerCase(); });
      var m = this.colorOf(parts[0]);
      if (!m) return null;
      return { m: m, s: parts[1] ? this.colorOf(parts[1]) : null };
    }
    colorOf(n) {
      if (!n) return null;
      var R = [
        [/rosé|rose|różow/, '#e3a995'],
        [/gold|złot|oro|^or$|doré/, '#d6b257'],
        [/schwarz|black|czarn|noir|negro|nero/, '#1f1f1f'],
        [/silber|silver|srebr|argent|plata|stahl|steel|titan/, '#c9cacd'],
        [/regenbogen|rainbow|aurora|tęcz|opal|(^|\s)ab$/, 'conic-gradient(#f5b8c8,#fbe3a1,#b9f0d0,#b6d6fb,#d9c2fb,#f5b8c8)'],
        [/aqua|türkis|turquoise|turkus/, '#3cc4cc'],
        [/blau|blue|niebiesk|bleu|azul|blu|saphir|sapphire/, '#2f62d6'],
        [/pink|rosa|róż/, '#f29bbf'],
        [/lila|violett|purple|fiolet|violet|morado|viola|amethyst/, '#8c5bd0'],
        [/grün|green|zielon|vert|verde|emerald|smaragd/, '#2fa36b'],
        [/rot|red|czerwon|rouge|rojo|rosso|rubin|ruby/, '#cf3036'],
        [/weiß|weiss|white|biał|blanc|blanco|bianco/, '#ffffff'],
        [/klar|kristall|clear|crystal|kryształ|przezroczy|cristal/, 'radial-gradient(circle at 35% 35%,#ffffff,#dfe5ec 60%,#b9c3cf)']
      ];
      for (var k = 0; k < R.length; k++) if (R[k][0].test(n)) return R[k][1];
      return null;
    }

    /* „1.2 mm“ → „1,2 mm“ (wie Produktseite), Bindestrich in Zahlenbereichen → Halbgeviertstrich */
    fmt(s) { s = String(s || ''); return this.komma ? s.replace(/(\d)\.(\d)/g, '$1,$2') : s; }
    dash(s) { return String(s || '').replace(/(\d)\s*-\s*(\d)/g, '$1–$2'); }

    unitPrice(v, qty) {
      if (v.p == null) return null;
      var price = v.p, step = null;
      (v.pb || []).slice().sort(function (a, b) { return a.q - b.q; }).forEach(function (b) {
        if (qty >= b.q) { price = b.p; step = b.q; }
      });
      return { price: price, step: step };
    }

    // true nur, wenn die Section für dieses Produkt die Live-Regel erfüllt („prices“: true);
    // Rückfall-Daten aus /products/<handle>.js haben nie Preise.
    pricesFor(row) {
      return !!(row.product && row.product.prices === true);
    }

    renderPrice(row) {
      var t = this.t, v = row.variant, el2 = row.price;
      el2.className = 'pp-sb__price';
      el2.textContent = '';
      // nicht gefunden: kein Preis-Hinweis, nur Strich wie bei der Lieferzeit
      if (row.state === 'notfound') { el2.textContent = '–'; el2.className += ' pp-sb__price--muted'; return; }
      if (!this.pricesFor(row)) {
        if (row.state !== 'empty' && row.state !== 'loading') { el2.textContent = t.priceLogin || 'after login'; el2.className += ' pp-sb__price--muted'; }
        return;
      }
      if (!v) return;
      var up = this.unitPrice(v, row.qty);
      if (!up) { el2.textContent = t.priceCart || 'in cart'; el2.className += ' pp-sb__price--muted'; return; }
      el2.className += ' pp-badge';
      el2.textContent = this.money.format(up.price / 100) + (up.step ? ' · ' + (t.priceFrom || 'from') + ' ' + up.step : '');
    }

    setMsg(html, kind) {
      if (!this.msg) return;
      this.msg.className = 'pp-sb__msg' + (kind ? ' pp-sb__msg--' + kind : '');
      this.msg.innerHTML = html;
    }

    /* ---------- CSV ---------- */
    applyCsv() {
      var ta = this.querySelector('.pp-sb__csv-input');
      if (!ta) return;
      var lines = ta.value.split(/\r?\n/), added = 0, self = this;
      // leere Zeilen am Ende weg, damit die neuen oben anschließen
      this.rows.filter(function (r) { return !r.inp.value.trim(); }).forEach(function (r) { r.tr.remove(); self.rows.splice(self.rows.indexOf(r), 1); });
      lines.forEach(function (line, i) {
        line = line.trim();
        if (!line) return;
        var sep = line.indexOf(';') >= 0 ? ';' : line.indexOf('\t') >= 0 ? '\t' : ',';
        var parts = line.split(sep).map(function (s) { return s.trim().replace(/^"|"$/g, ''); });
        var sku = parts[0], qty = parseInt(parts[1], 10), name = parts.slice(2).join(sep === ',' ? ', ' : ' ').trim();
        if (!sku) return;
        if (i === 0 && isNaN(qty) && /artikel|sku|nummer|art\.?-?nr|item|r[ée]f|art[ií]culo|articolo|article|artyku|numer/i.test(sku)) return; // Kopfzeile
        self.addRow({ sku: sku, qty: isNaN(qty) ? 1 : qty, name: name });
        added++;
      });
      this.ensureEmptyRow();
      this.save();
      if (added) {
        ta.value = '';
        this.setMsg(this.escape(((added === 1 && this.t.csvDoneOne) || this.t.csvDone || '[count]').replace('[count]', added)), 'ok');
        var det = this.querySelector('.pp-sb__csv'); if (det) det.open = false;
      }
    }

    escape(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    /* ---------- Warenkorb ---------- */
    addToCart(btn) {
      var t = this.t, self = this;
      var pending = this.rows.filter(function (r) { return r.state === 'loading'; });
      if (pending.length) { setTimeout(function () { self.addToCart(btn); }, 400); return; }
      var good = this.rows.filter(function (r) { return r.state === 'ok' && r.variant; });
      var bad = this.rows.filter(function (r) { return r.sku && r.state !== 'ok'; });
      if (!good.length) { this.setMsg(this.escape(t.empty || ''), 'err'); if (bad[0]) bad[0].inp.focus(); return; }

      var items = good.map(function (r) {
        var it = { id: r.variant.id, quantity: r.qty };
        var nm = (r.name || '').trim();
        if (nm) it.properties = { message: nm };
        return it;
      });
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      fetch(this.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: ['cart-icon-bubble'], sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false; btn.removeAttribute('aria-busy');
          if (!res.ok) {
            var desc = res.j && (res.j.description || res.j.message) || '';
            self.setMsg(self.escape((t.error || '') + ' ' + desc), 'err');
            return;
          }
          self.updateBubble(res.j && res.j.sections);
          var count = items.reduce(function (s, it) { return s + it.quantity; }, 0);
          if (self.afterAdd === 'cart') { store(false, null); window.location.href = self.cartUrl; return; }
          // erfolgreiche Zeilen entfernen, Fehlerzeilen bleiben stehen
          good.forEach(function (r) { r.tr.remove(); self.rows.splice(self.rows.indexOf(r), 1); });
          self.ensureEmptyRow();
          self.save();
          var html = self.escape(((count === 1 && t.addedOne) || t.added || '').replace('[count]', count)) +
            ' <a class="pp-sb__cartlink" href="' + self.cartUrl + '">' + self.escape(t.toCart || '') + ' →</a>';
          if (bad.length) html += ' <span class="pp-sb__msg-sub">' + self.escape(t.skipped || '') + '</span>';
          self.setMsg(html, 'ok');
        })
        .catch(function (e) {
          btn.disabled = false; btn.removeAttribute('aria-busy');
          self.setMsg(self.escape((t.error || '') + ' ' + (e && e.message || '')), 'err');
        });
    }

    updateBubble(sections) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections && sections['cart-icon-bubble']) {
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pp-quick-order' });
      } catch (e) {}
    }
  }

  customElements.define('pp-quick-order', PpQuickOrder);
})();
